import React from 'react';
import { SectionWrapper } from './SectionWrapper';
export function Problem() {
  return <SectionWrapper data-id="element-169">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 text-charcoal" data-id="element-170">
        Después de los 40, las reglas del juego cambian.
      </h2>
      <div className="bg-white p-8 md:p-10 rounded-2xl shadow-sm border border-gray-100" data-id="element-171">
        <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-6" data-id="element-172">
          El estrés cotidiano, la falta de sueño y la caída de la progesterona
          disparan una señal de alarma en tu cuerpo:{' '}
          <strong className="text-coral" data-id="element-173">el cortisol</strong>.
        </p>
        <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-6" data-id="element-174">
          Esta hormona le ordena a tu organismo almacenar grasa precisamente en
          el abdomen para "protegerte" del peligro. Por eso, las dietas de 1,200
          calorías y el running intenso solo empeoran las cosas; le dicen a tu
          cuerpo que el peligro es real y la inflamación aumenta.
        </p>
        <p className="text-lg md:text-xl text-gray-700 leading-relaxed font-medium" data-id="element-175">
          Estás atrapada en un ciclo de hinchazón crónica que ninguna ensalada
          de lechuga puede solucionar.
        </p>
      </div>
    </SectionWrapper>;
}